import antdTranslations from "antd/lib/locale-provider/pl_PL";

export default {
   antd: antdTranslations,
   locale: "pl"
};
